<template>
    <form class="admin-plan-form" @submit.prevent="proceed" @keydown="planForm.errors.clear($event.target.name)">
        <div class="row admin-plan-form__row">
            <div class="col-12 col-md-4 form-group">
                <label for="">{{trans('plan.name')}} </label>
                <input class="form-control" type="text" v-model="planForm.name" name="name" :placeholder="trans('plan.name')">
                <show-error :form-name="planForm" prop-name="name"></show-error>
            </div>
            <div class="col-12 col-md-4 form-group">
                <label for="">{{trans('plan.code')}}</label>
                <input class="form-control" type="text" v-model="planForm.code" name="code" :placeholder="trans('plan.code')">
                <show-error :form-name="planForm" prop-name="code"></show-error>
            </div>
            <div class="col-12 col-md-4 form-group">
                <label for="">{{trans('plan.max_student')}}</label>
                <input class="form-control" type="number" v-model="planForm.max_student" name="max_student" :placeholder="trans('plan.max_student')">
                <show-error :form-name="planForm" prop-name="max_student"></show-error>
            </div>
        </div>

        <div class="form-group admin-plan-form__desc">
            <label for="">{{trans('plan.description')}}</label>
            <textarea class="form-control" rows="4" name="description" :placeholder="trans('plan.description')" v-model="planForm.description"></textarea>
            <show-error :form-name="planForm" prop-name="description"></show-error>
        </div>
        <div class="form-group">
            <label for="">{{trans('plan.features')}}</label>
            <textarea class="form-control" rows="6" name="features" :placeholder="trans('plan.features_placeholder')" v-model="planForm.features"></textarea>
            <show-error :form-name="planForm" prop-name="features"></show-error>
        </div>

        <div class="admin-plan-form__switches">
            <div class="admin-plan-form__switch-row">
                <div class="admin-plan-form__switch-meta">
                    <span class="admin-plan-form__switch-label">{{trans('plan.status')}}</span>
                    <show-tip type="field" module="plan" tip="tip_status"></show-tip>
                </div>
                <switches v-model="planForm.is_active" theme="bootstrap" color="success"></switches>
            </div>
            <div class="admin-plan-form__switch-row">
                <div class="admin-plan-form__switch-meta">
                    <span class="admin-plan-form__switch-label">{{trans('plan.default')}}</span>
                    <show-tip type="field" module="plan" tip="tip_default"></show-tip>
                </div>
                <switches v-model="planForm.is_default" theme="bootstrap" color="success"></switches>
            </div>
            <div class="admin-plan-form__switch-row">
                <div class="admin-plan-form__switch-meta">
                    <span class="admin-plan-form__switch-label">{{trans('plan.featured')}}</span>
                    <show-tip type="field" module="plan" tip="tip_featured"></show-tip>
                </div>
                <switches v-model="planForm.is_featured" theme="bootstrap" color="success"></switches>
            </div>
        </div>

        <div v-for="plan_price in planForm.plan_prices" :key="plan_price.currency.id" class="admin-plan-price-card">
            <h4 class="admin-plan-price-card__title"><admin-icon name="rupee" class="mr-1"></admin-icon>{{plan_price.currency.name+' ('+plan_price.currency.symbol+')'}}</h4>
            <div class="row">
                <div class="col-12 col-sm-6 form-group" v-for="frequency in plan_price.frequencies" :key="frequency.payment_frequency.id">
                    <label for="">{{frequency.payment_frequency.name}}</label>
                    <input class="form-control" type="number" step=".01" v-model="frequency.amount" :name="getAmountFieldName(plan_price,frequency)" :placeholder="trans('plan.amount')">
                    <show-error :form-name="planForm" :prop-name="getAmountFieldName(plan_price,frequency)"></show-error>
                </div>
            </div>
        </div>

        <div class="admin-plan-form__actions">
            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">
                <admin-icon name="check"></admin-icon>
                <span v-if="id">{{trans('general.update')}}</span>
                <span v-else>{{trans('general.save')}}</span>
            </button>
            <router-link v-show="id" to="/plan" class="btn btn-sm admin-form-btn-cancel"><admin-icon name="close" class="mr-1"></admin-icon>{{trans('general.cancel')}}</router-link>
        </div>
    </form>
</template>


<script>
    import switches from 'vue-switches'

    export default {
        components: {switches},
        data() {
            return {
                planForm: new Form({
                    name : '',
                    code : '',
                    is_active: '',
                    is_default: '',
                    is_featured: '',
                    max_student: '',
                    description: '',
                    features: '',
                    plan_prices: []
                }),
                currencies: [],
                payment_frequencies: []
            };
        },
        props: ['id'],
        mounted() {
            axios.get('/api/plan/pre-requisite')
                .then(response => response.data)
                .then(response => {
                    this.currencies = response.currencies;
                    this.payment_frequencies = response.payment_frequencies;

                    this.initPlanPrice();

                    if(this.id)
                        this.getPlan();
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods: {
            initPlanPrice(){
                this.currencies.forEach(currency => {
                    let frequencies = [];
                    this.payment_frequencies.forEach(payment_frequency => {
                        frequencies.push({
                            payment_frequency: payment_frequency,
                            amount: ''
                        })
                    });

                    this.planForm.plan_prices.push({
                        currency: currency,
                        frequencies: frequencies
                    });
                });
            },
            proceed(){
                if(this.id)
                    this.updatePlan();
                else
                    this.storePlan();
            },
            storePlan(){
                this.planForm.post('/api/plan')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed');
                        this.planForm.plan_prices = [];
                        this.initPlanPrice();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getPlan(){
                axios.get('/api/plan/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.planForm.name = response.name;
                        this.planForm.code = response.code;
                        this.planForm.is_active = response.is_active;
                        this.planForm.is_default = response.is_default;
                        this.planForm.is_featured = response.is_featured;
                        this.planForm.max_student = response.options.max_student;
                        this.planForm.description = response.description;
                        let features = response.options && response.options.features ? response.options.features : [];
                        this.planForm.features = Array.isArray(features) ? features.join('\n') : (features || '');

                        this.planForm.plan_prices.forEach(plan_price => {
                            plan_price.frequencies.forEach(frequency => {
                              let price = response.plan_price.find(o => o.currency_id == plan_price.currency.id && o.frequency === frequency.payment_frequency.id);
                              frequency.amount = price ? helper.formatNumber(price.amount,plan_price.currency.decimal_place) : 0;
                            })
                        });
                    })
                    .catch(error => {
                        this.$router.push('/plan');
                    });
            },
            updatePlan(){
                this.planForm.patch('/api/plan/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/plan');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getAmountFieldName(plan_price,frequency){
                return 'plan_price_'+plan_price.currency.id+'_'+frequency.payment_frequency.id;
            }
        }
    }
</script>
